// stores/toast.js
import { defineStore } from 'pinia'

export const useToastStore = defineStore('toast', {
  state: () => ({
    show: false,
    message: '',
    type: 'error', // 'success', 'error', 'warning', 'info'
    duration: 3000,
  }),

  actions: {
    showToast(message, type = 'error', duration = 3000) {
      this.message = message
      this.type = type
      this.duration = duration
      this.show = true

      // 자동 닫기
      setTimeout(() => {
        this.closeToast()
      }, duration)
    },

    closeToast() {
      this.show = false
    },
  },
})